import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../../utils";
import { CreateM018 } from "./dataService/dto";

interface M018State {
    // REQUEST
    createNewM018: CreateM018
}

const initialState: M018State = {
    // REQUEST
    createNewM018: {}

}

const M018Slice = createSlice({
    name: 'odc/slice',
    initialState,
    reducers: {
        // REQUEST [CREATION]
        setCreateDateM018: (state, action) => {
            state.createNewM018.m018Date = action.payload
        },
        setCreateUserM018: (state, action) => {
            state.createNewM018.userId = action.payload
        },
        setCreateReportingM018: (state, action) => {
            state.createNewM018.reportingId = action.payload
        },
        setCreateCustomerIdM018: (state, action) => {
            state.createNewM018.customerId = action.payload
        },
        
    }
})

export const {
    //REQUEST
    setCreateCustomerIdM018,
    setCreateDateM018,
    setCreateReportingM018,
    setCreateUserM018

} = M018Slice.actions

export default M018Slice.reducer